import styled from 'styled-components'

import Text, { TextSize } from 'src/components/Typography/Text'

export const StyledHeader = styled(Text).attrs(() => ({ strong: true, size: TextSize.Large }))`
  display: block;
  padding: 6px 6px 4px 0;
  color: ${({ theme }) => theme.colorTextSecondary};
  border-bottom: 1px solid ${({ theme }) => theme.colorFillSecondary};
`
export const StyledSubHeader = styled(Text).attrs(() => ({ strong: true }))`
  display: block;
  padding: 6px;
  color: ${({ theme }) => theme.colorTextTertiary};
`
